<template>
  <div id="tenantList">
    <el-row class="header-row">
      <el-col :span="24">
        <h3 class="el-page-header">Tenants</h3>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/tenants' }">Tenants</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-card>
      <div v-if="loading" v-loading="loading" class="top-margin" element-loading-spinner="atom-audit-loader" style="min-height: 150px;"></div>
      <div v-if="!loading">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-button @click="addTenant" class="hiaButton" plain round size="mini"> <i class="mdi mdi-plus"></i>Add Tenant </el-button>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px;">
          <el-col :span="24">
            <v-client-table style="margin-top: 15px;" v-loading="loading" element-loading-spinner="atom-audit-loader" class="hiaTable" id="tenantsGrid" ref="tenantsGrid" :data="tenants" :columns="columns" :options="options">
              <template slot="tenantName" slot-scope="props">
                <router-link :to="`/tenants/${props.row.tenantId}`">{{ props.row.tenantName }}</router-link>
              </template>
              <template slot="active" slot-scope="props">
                <div style="text-align: center;">
                  <i :style="props.row.active ? 'color: #13ce66; font-size: 16px; font-weight: bold;' : 'color: #F56C6C; font-size: 16px; font-weight: bold;'" :class="props.row.active ? 'el-icon-check' : 'el-icon-close'"></i>
                </div>
              </template>
              <template slot="isClient" slot-scope="props">
                <div style="text-align: center;">
                  <i :style="props.row.isClient ? 'color: #13ce66; font-size: 16px; font-weight: bold;' : 'color: #F56C6C; font-size: 16px; font-weight: bold;'" :class="props.row.isClient ? 'el-icon-check' : 'el-icon-close'"></i>
                </div>
              </template>
              <template slot="contractEndDate" slot-scope="props">
                {{ props.row.contractEndDate ? format(parseISO(props.row.contractEndDate), 'M/dd/yyyy') : '' }}
              </template>
            </v-client-table>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from '@/utilities/axios-global'
  import { format, parseISO } from 'date-fns'

  export default {
    name: 'TenantList',
    data() {
      return {
        format: format,
        parseISO: parseISO,
        loading: true,
        tenants: [],
        columns: ['tenantName', 'dbName', 'active', 'isClient', 'contractEndDate'],
        options: {
          headings: {
            tenantName: 'Tenant Name',
            dbName: 'Database Name',
            active: 'Active',
            isClient: 'Is Client',
            contractEndDate: 'Contract End Date'
          },
          columnsClasses: {
            active: 'sm',
            isClient: 'sm'
          }
        }
      }
    },
    computed: {
      ...mapState('user', ['baseApiUrl', 'currentTenantGuid'])
    },
    methods: {
      async loadTenants() {
        this.loading = true
        try {
          const response = await axios.get(`${this.baseApiUrl}/tenantAdmin/tenants`)
          this.tenants = response.data || []
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error loading tenants:', error)
          this.$message.error('Failed to load tenants')
        } finally {
          this.loading = false
        }
      },
      addTenant() {
        this.$router.push('/add-tenant')
      }
    },
    created() {
      this.loadTenants()
    }
  }
</script>

<style scoped>
  #tenantList >>> .caret-wrapper {
    display: none;
  }

  >>> .sm {
    width: 75px;
  }
</style>
